import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Spinner from "./Spinner";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { token, role } = useSelector((state) => state.auth);

  // Redirect to external site safely
  if (!token) {
    window.location.replace("https://dreamdor.com");
    return <Spinner />; // prevent rendering during redirect
  }

  // Redirect to unauthorized page if role is not allowed
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;

// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const { token, role } = useSelector((state) => state.auth);

//   if (!token) return (window.location.href = "https://dreamdor.com");
//   if (allowedRoles && !allowedRoles.includes(role))
//     return <Navigate to="/unauthorized" replace />;

//   return children;
// };

// export default ProtectedRoute;
